
import axios from 'axios';
import { getRefreshToken, setAccessToken, clearTokens } from './token';
import { Message } from 'element-ui';
import { refreshToken as requestRefreshToken } from '@/api/login/login';
let isRefreshing = false;
let subscribers = [];

function onRefreshed(token) {
  subscribers.forEach(cb => cb(token));
  subscribers = [];
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

export async function handle401Error(error, instance) {
  const { config, response } = error;

  if (!response || response.status !== 401 || config.__isRetryRequest) {
    return Promise.reject(error);
  }

  if (!isRefreshing) {
    isRefreshing = true;
    const params = new URLSearchParams({
      refreshToken: getRefreshToken(),
      grantType: 'refresh_token',
      scope: 'all'
    });
    
    try {
      const res = await requestRefreshToken(getRefreshToken());
      const newToken = res.data.accessToken;
      setAccessToken(newToken);
      onRefreshed(newToken);
    } catch (e) {
      clearTokens();
      Message.error('登录已过期，请重新登录');
      window.location.href = '/';
      return Promise.reject(e);
    } finally {
      isRefreshing = false;
    }
  }

  return new Promise(resolve => {
    addSubscriber(token => {
      config.headers['Authorization'] = `Bearer ${token}`;
      config.__isRetryRequest = true;
      resolve(instance(config));
    });
  });
}
